import React from "react";
import { useSharedDataContext } from '../SharedDataContext';
import MaskedInput from "react-text-mask";
import { useState } from "react";
import { useEffect } from "react";
import { getMaskForNameWithMaxLength, isMobileNotValid } from "../utility/utilityFunction";
import { useFormik } from 'formik';

const OwnDetails = (props) => {
    const { sharedData, setSharedData } = useSharedDataContext({});
    const [BtnVal, setBtnVal] = useState("Continue");
    const initialValues = {
        ownername: "",
        mobileno: ''
    }

   


    const validateForm = (values) => {
        const { ownername, mobileno } = values;
        const errors = {};
        if (ownername.trim() === "") {
            errors["ownername"] = "Please enter owner name";
        } else if (ownername.trim().length <2) {
            errors["ownername"] = "Please enter valid owner name";
        }
        if (mobileno === "") {
            errors["mobileno"] = "Please enter mobile number";
        } else if (mobileno.length !== 10 || isMobileNotValid(mobileno)) {
            errors["mobileno"] = "Please enter valid mobile number";
        }
        return errors;
    }

    const { handleSubmit, values, setFieldValue, handleChange, handleBlur, errors, touched, setFieldTouched } = useFormik({
        initialValues,
        validate: validateForm,
        onSubmit: (values, {setSubmitting }) => {
            const { ownername, mobileno } = values;
            setBtnVal("Wait...")
            
            const updateddata = {
                ...sharedData,
                ownername: ownername,
                mobileno: mobileno,
            }
            setSharedData({...updateddata});
            console.log("Updating sharedData with:", updateddata);
            props.setOwnerName(ownername);
            props.HideOwnDetails(!props.HideOwnDetails)
            props.ShowPdetails(true);
            setSubmitting(false);
        }
    });

    useEffect(() => {
        if (sharedData.ownername) {
            setFieldValue('ownername', sharedData.ownername);
        }
        if (sharedData.mobileno) {
            setFieldValue('mobileno', sharedData.mobileno);
        }
    }, [])


   

    return (
        <div className="SameForm SameForm2">
            <h2 className="formHeading ownDetails">Owner Details</h2>
            <div className="PetInput CapitalizeName">
                <MaskedInput
                    mask={getMaskForNameWithMaxLength(50)}
                    guide={false} showMask={false}
                    onKeyDown={(e) => {
                        // Prevent typing multiple consecutive spaces
                        const { value, selectionStart } = e.target;
                        if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                            e.preventDefault();
                        }
                    }}
                    onChange={(e) => {
                        // Ensure no leading spaces or multiple spaces
                        const processedValue = e.target.value
                            .replace(/^\s+/, '') // Remove leading spaces
                            .replace(/\s{2,}/g, ' '); // Replace multiple spaces with a single space

                        setFieldValue('ownername', processedValue);
                    }}
                    onBlur={() => setFieldTouched('ownername', true)}
                    value={values.ownername}
                    name='ownername'
                    placeholder=" " id="ForUp1" className="InputBox"

                />
                <label htmlFor="ForUp1" className="floating_label">Owner Name</label>
                {(errors.ownername && touched.ownername) && <span className="Error">{errors["ownername"]}</span>}
                <div className="inputIcon">
                    <img src={require("../../assets/images/user.svg").default} alt="" />
                </div>
            </div>
            <div className="PetInput">
                <MaskedInput type="tel"
                    mask={[/[6-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                    minLength="10"
                    value={values.mobileno}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name='mobileno'
                    guide={false} showMask={false} style={{ textTransform: "uppercase" }} placeholder=" " id="ForUp2" className="InputBox" />
                <label htmlFor="ForUp2" className="floating_label">Mobile Number</label>
                {(errors.mobileno && touched.mobileno) && <span className="Error">{errors["mobileno"]}</span>}
                <div className="inputIcon">
                    <img src={require("../../assets/images/mobile.svg").default} alt="" />
                </div>
            </div>
            <button type="submit" className="SMCBTN" onClick={handleSubmit}>{BtnVal}</button>
        </div>
    )
}
export default OwnDetails;